import { ReactNode } from 'react';
import Slider, { Settings } from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Box, Container, SxProps, Theme, useTheme } from '@mui/material';

interface ImageCarouselProps {
  children: ReactNode;
  sx?: SxProps<Theme> | undefined;
}

const ImageCarousel = ({ children, sx }: ImageCarouselProps) => {
  const theme = useTheme();

  const style = {
    ...sx,
    '& .slick-prev:before, & .slick-next:before': {
      color: theme.palette.primary.main,
    },
    '& .slick-dots li.slick-active button:before': {
      color: theme.palette.primary.main,
    },
  };

  const settings: Settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    adaptiveHeight: true,
    lazyLoad: "ondemand"
  };

  return (
    <Box className="slider-container" sx={style}>
      <Slider {...settings}>
        {children}
      </Slider>
    </Box>
  );
}

export default ImageCarousel;
